console.clear();
var { Sidechain } = require("@nprapps/sidechain");
Sidechain.registerGuest();

var PA = require("./pa_simplified.geojson");

var $ = require("./lib/qsa");
var leaflet = require("leaflet");
var colors = require("./lib/helpers/colors");

var data = Object.fromEntries(window.DATA.map(d => [d.county.toUpperCase(), d]));

var palette = {
  Yes: colors.purple2,
  No: colors.peach2
}

var map = new leaflet.Map($.one(".map"), {
  zoomSnap: .1,
  scrollWheelZoom: false,
  touchZoom: false,
  zoomControl: false,
  dragging: false,
  keyboard: false
});

var geojson = new leaflet.GeoJSON(PA, {
  style({ properties }) {
    var name = properties.COUNTY_NAM;
    var lookup = data[name];
    return {
      color: "white",
      weight: 1,
      fillOpacity: 1,
      fillColor: palette[lookup.curing] || "#EEE"
    };
  }
});
geojson.addTo(map);
map.fitBounds(geojson.getBounds());

window.addEventListener("resize", () => map.fitBounds(geojson.getBounds()));

var details = $.one(".details");

function setDetails(county) {
  var item = data[county];
  var { questions } = window.LABELS;
  geojson.eachLayer(layer => {
    var { properties } = layer.feature;
    var matched = county == properties.COUNTY_NAM;
    layer.setStyle({
      color: matched ? "#0009" : "white",
      weight: matched ? 2 : 1
    });
    if (matched) layer.bringToFront();
  })
  details.innerHTML = `
<h3 tabindex=-1>${item.county} County</h3>

${item.current ? `<i>${item.current}</i>` : ""}

<p><b>${questions.notice_policy}</b> ${item.notice_policy}

<p><b>${questions.cure_policy}</b> ${item.cure_policy}
  `;
  var h3 = details.querySelector("h3");
  h3.scrollIntoView({ behavior: "smooth", block: "nearest" });
  h3.focus({ preventScroll: true });
}

geojson.on("click", function(e) {
  var county = e.layer?.feature?.properties?.COUNTY_NAM;
  setDetails(county);
});

var select = $.one(".county-select select");
select.addEventListener("input", () => select.value && setDetails(select.value));